const ZONE_INCHES_UPPER_LIMIT = 9
const ZONE_INCHES_LIMIT = 3

module.exports = {
    ZONE_INCHES_UPPER_LIMIT,
    ZONE_INCHES_LIMIT,
}
